"use client";

import { useReducedMotion } from "framer-motion";
import { useSyncExternalStore } from "react";

function subscribeToHydration() {
  return () => {
    // No runtime subscription is required; we only need server/client snapshots.
  };
}

function getClientHydrationSnapshot() {
  return true;
}

function getServerHydrationSnapshot() {
  return false;
}

/**
 * Hydration-safe reduced-motion preference.
 *
 * On the server and on the first client render, this returns `false` so the
 * rendered tree is deterministic and does not trigger hydration mismatches.
 * After mount, it reflects the user's actual media-query preference.
 */
export function useSafeReducedMotion(): boolean {
  const prefersReducedMotion = useReducedMotion();
  const hasHydrated = useSyncExternalStore(
    subscribeToHydration,
    getClientHydrationSnapshot,
    getServerHydrationSnapshot,
  );

  if (!hasHydrated) {
    return false;
  }

  return Boolean(prefersReducedMotion);
}
